<template>
  <div
    class="bk-blokkli-item-options-group"
    :class="{ 'bk-is-active': isActive }"
  >
    <button @click.stop.prevent="$emit('toggle')">
      <div>{{ label }}</div>
      <Icon name="caret" />
    </button>
    <div v-if="isActive" class="bk-blokkli-item-options-group-content">
      <slot />
    </div>
  </div>
</template>

<script setup>
import { Icon } from "#blokkli/components";
defineProps({
  label: { type: String, required: true },
  isActive: { type: Boolean, required: true }
});
defineEmits(["toggle"]);
</script>
